<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="rotate-refresh-loading"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <path id="Path_8338" data-name="Path 8338" d="M0,0H22V22H0Z" fill="none" />
    <path
      id="Path_8339"
      data-name="Path 8339"
      d="M6.437,7.937H3V4.5"
      transform="translate(-0.25 -0.375)"
      fill="none"
      :stroke="clr ? clr : `#fff`"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8340"
      data-name="Path 8340"
      d="M19.569,11.25A8.246,8.246,0,0,0,3.826,7.813"
      transform="translate(-0.319 -0.25)"
      fill="none"
      :stroke="clr ? clr : `#fff`"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8341"
      data-name="Path 8341"
      d="M17.25,15.75h3.437v3.438"
      transform="translate(-1.437 -1.312)"
      fill="none"
      :stroke="clr ? clr : `#fff`"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_8342"
      data-name="Path 8342"
      d="M3,12a8.246,8.246,0,0,0,15.743,3.437"
      transform="translate(-0.25 -1)"
      fill="none"
      :stroke="clr ? clr : `#fff`"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path id="Path_8343" data-name="Path 8343" d="M0,0H22V22H0Z" fill="none" />
  </svg>
</template>
